import { useMutation } from '@apollo/client';
import { useParams } from 'react-router-dom';
import { useSetBreadcrumbEffect } from '../../contexts/BreadcrumbContext';
import { UpsertTeamMembersMutation } from '../../mutations';
import { MyTeamsQuery, TeamQuery } from '../../queries';
import { useIsSuperadminRoute, useQueryWithMsg } from '../../utils/hooks';
import TeamMemberForm from './TeamMemberForm';

const AddTeamMember = () => {
  const { teamId } = useParams();
  const isSuperadminRoute = useIsSuperadminRoute();

  // Fetch the team we are adding the member to.
  const { msg, data: teamData } = useQueryWithMsg(TeamQuery, {
    variables: { id: teamId },
  });

  const breadcrumbs = [
    {
      display: 'Team Members',
      url: `:rootUrl/${isSuperadminRoute ? `${teamId}/` : ''}members`,
    },
    { display: 'Add Member' },
  ];
  useSetBreadcrumbEffect(breadcrumbs, []);

  const [mutation] = useMutation(UpsertTeamMembersMutation, {
    refetchQueries: [
      { query: TeamQuery, variables: { id: teamId } },
      { query: MyTeamsQuery },
    ],
  });

  return (
    msg || (
      <TeamMemberForm
        mutation={mutation}
        submitButtonText="Add Member"
        team={teamData.team}
      />
    )
  );
};

export default AddTeamMember;
